import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { InspectionRequestItem } from '../../../../../graphql/generated/graphql';
import LfToBr from '../../../primitive/LfToBr';

interface Props {
  item: InspectionRequestItem;
  className?: string;
}

const Item = ({ item, className }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <Typography variant="caption">{item.type.label}</Typography>

    <Body variant="body1">
      <LfToBr text={item.body} />
    </Body>
  </Root>
);

const Root = styled('div')();

const Body = styled(Typography)({
  wordBreak: 'break-word' as any,
  wordWrap: 'break-word',
  hyphens: 'auto',
});

export default Item;
